<template>
  <div class="success-return-page row">

    <div class="col-12">
      <Hero
        image="banner-home.png"
        layout="lg"
        title=""
      />
    </div>

    <div class="col-12">
      <div class="row pb-5">
        <div class="col-12 col-lg-8 mx-auto mt-n5">
          <div class="bg-white shadow-sm p-5">

            <div class="d-flex flex-column flex-md-row align-items-center justify-content-center">
              <progress-check-icon style="font-size:110px;" class="text-color-1" />
              <div>
                <h4 class="m-3 text-muted font-weight-normal">
                  {{ username }},
                  <br />sua candidatura foi realizada com sucesso!
                </h4>

                <p class="m-3 h5 text-muted font-weight-normal">
                  <span class="text-color-1">FIQUE DE OLHO NO SEU E-MAIL DE CADASTRO</span>, <br>
                  nos próximos dias alguém da Bluefit poderá entrar em contato com você pelo e-mail <strong>no-reply@99jobs.com</strong> para participar das próximas etapas.
                  <br>
                  <br>
                  Boa Sorte!!
                </p>
              </div>
            </div>

            <div class="text-center my-5" v-if="tests && tests.length > 0">
                <h4>Você tem alguns testes pendentes para serem feitos</h4>
              </div>

              <div class="d-flex align-items-center p-3 bg-light-2 shadow-sm mb-4" v-for="(test, i) in tests">
                <file-document-outline-icon class="mr-2" style="font-size:30px;" v-if="test.status == 'pending'" />
                <file-check-outline-icon class="mr-2 text-green-ml" style="font-size:30px;" v-if="test.status == 'finished'" />

                <div class="mr-2">
                  <h6>{{ test.name }}</h6>
                  <span v-if="test.status == 'pending'">Pendente</span>
                  <span v-if="test.status == 'finished'">Finalizado</span>
                </div>

                <button v-if="test.source != 'ninenine_jobs' && test.status == 'pending'"  @click="alertPartner(test.url)" class="btn btn-color-1 ml-auto d-flex align-items-center">
                  Começar <chevron-right-icon class="h3 ml-5 mb-0" />
                </button>

                <button v-if="test.source == 'ninenine_jobs' && test.status == 'pending'" @click="goToTest(`${test.name}/${test.test_id}`)" class="btn btn-color-1 ml-auto d-flex align-items-center">
                  Começar <chevron-right-icon class="h3 ml-5 mb-0" />
                </button>
              </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import LoaderContent from '@/components/loader/LoaderContent.vue'
  import Hero from '@/components/media/Hero.vue'
  import ProgressCheckIcon from "vue-material-design-icons/ProgressCheck.vue"
  import AlertCircleIcon from "vue-material-design-icons/AlertCircle.vue";
  import FileAlertIcon from "vue-material-design-icons/FileAlert.vue";
  import FileCheckIcon from "vue-material-design-icons/FileCheck.vue";
  import FileDocumentOutlineIcon from "vue-material-design-icons/FileDocumentOutline.vue";
  import FileCheckOutlineIcon from '@/components/mlIcons/FileCheckOutline';
  import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue";

  export default {
    name: 'SubscriptionSuccessReturn',

    data() {
      return {
        isLoading: false,
        tests: [],
        opportunity: null,
      }
    },

    computed: {
      opportunityId(){
        const id = this.$route.query.id.match(/\d+/)[0]
        return id
      },

      username() {
        return this.$store.state.user.profile.name.split(' ')[0]
      }
    },

    components: {
      LoaderContent,
      Hero,
      ProgressCheckIcon,
      AlertCircleIcon,
      FileAlertIcon,
      FileCheckIcon,
      FileDocumentOutlineIcon,
      FileCheckOutlineIcon,
      ChevronRightIcon
    },

    beforeDestroy() {
      document.getElementById("someExtraContent").innerHTML = '';
    },

    async mounted() {
      this.isLoading = true;
      await this.getOpportunity();

      this.$store.dispatch('tests/subscriptionTests', {
        opportunityId: this.opportunityId,
        finishedTests: false,
        requiredIn: 'thank_you'
      }).then(tests => {
        this.tests = tests.subscriptionTests.json || []
        this.tests = this.tests.filter(test => test.hide_to_candidate == false);
        this.isLoading = false
      });
    },

    methods: {
      async getOpportunity(){
        let counter = 0;

        const get = () => {
          this.$store.dispatch("opportunities/getOpportunity", this.$route.query.id).then((opportunity) => {
            if (opportunity) {
              this.opportunity = opportunity;
              this.notFound = false;
              this.pageTitle = this.$helpers.toTitle(this.opportunity.title);
              this.$emit("updateHead");
            }  else {
              this.notFound = true;
            }
          });
        };

        get();
      },

      goToTest(testId){
        window.afterTestBackTo = this.$route.fullPath;
        this.$router.push(`vagas/${this.opportunity.id}/inscricao/${ testId }`);
      },

      alertPartner(link) {
        this.$swal({
          title: "Atenção",
          text: "Você será direcionado para realizar o teste.",
          type: "info",
          showCancelButton: true,
          cancelButtonText: "Fechar",
          confirmButtonText: "Vamos lá!",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            window.open(link, '_blank');
          }
        });
      },
    },

  }
</script>

<style lang="scss" scoped>
  .success-return-page{
    background: #F5F5F5;
  }

  /deep/ .hero{
    height: 450px;
    min-height: auto;
    margin-top: 123px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .media-content img{
      object-position: center !important;
    }

    @media (max-width: 600px){
      background-size: cover;
    }
  }
</style>